import { render, staticRenderFns } from "./the-integrations.vue?vue&type=template&id=0f022a7e&scoped=true"
import script from "./the-integrations.vue?vue&type=script&lang=js"
export * from "./the-integrations.vue?vue&type=script&lang=js"
import style0 from "./the-integrations.vue?vue&type=style&index=0&id=0f022a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f022a7e",
  null
  
)

export default component.exports